<template>
  <div
    v-if="mediaItem"
    :class="[
      'media_item',
      parent === 'EditListing' ? 'responsive' : '',
    ]"
  >
    <button
      v-if="canEditLocation"
      class="remove_btn"
      @click="openEditModal = true"
    >
      <i class="fas fa-pencil" />
    </button>
    <div class="thumbnail">
      <img
        :src="scaledGoogleUrl"
        referrerpolicy="no-referrer"
        @click="openMediaItemPreviewModal(mediaItem.google_url)"
      >
    </div>
    <div
      v-if="parent !== 'EditListing'"
      class="media_info"
    >
      <span class="green_label">
        {{ mediaItem.category.replace('_', ' ').toLowerCase() }}
      </span>
    </div>
  </div>

  <add-media
    v-else
    :responsive="true"
    :class="!canEditLocation ? 'disabled' : ''"
    @click="canEditLocation ? openEditModal = true : null"
  >
    Add {{ type === 'profile' ? 'Profile' : 'Cover' }} Picture
  </add-media>

  <edit-profile-cover-media-item-modal
    v-if="openEditModal"
    :type="type"
    @close="openEditModal = false"
  />
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AddMedia from "../items/AddMedia";
import EditProfileCoverMediaItemModal from "../modals/EditProfileCoverMediaItemModal";

export default {
  components: {
    EditProfileCoverMediaItemModal,
    AddMedia,
  },
  props: {
    mediaItem: {
      type: [Object, null],
      required: true,
      visible: false,
    },
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['cover', 'profile'].includes(value);
      }
    },
    parent: {
      type: String,
      required: true,
      validator(value) {
        return ['EditListing', 'ManageMedia'].includes(value)
      }
    }
  },
  data() {
    return {
      openEditModal: false,
    }
  },
  computed: {
    ...mapGetters('user', [
      'canEditLocation',
    ]),
    ...mapGetters('businessProfile', [
      'selectedLocation',
    ]),
    scaledGoogleUrl() {
      if (this.type === 'profile') {
        return this.mediaItem.google_url.replace(new RegExp("\\=s0$"), '=s160-c');
      }
      return this.mediaItem.google_url;
    },
  },
  methods: {
    ...mapActions('businessProfile', [
      'editProfileMediaItem',
      'openMediaItemPreviewModal',
    ])
  }
}
</script>

<style lang="scss" scoped>
.media_item {
  width: 230px;
  height: 230px;
  border: 1px solid #F7F5F2;
  border-radius: 0.75rem;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;

  &.responsive {
    height: 100%;
    width: 100%;
    margin-top: 0;
    border: 2px solid #37B2A8;
    border-radius: 0.75rem;

    > .thumbnail {
      height: 100%;
    }
  }

  > .remove_btn {
    background-color: rgba(0, 0, 0, 0.5);
    color: #FFFFFF;
    position: absolute;
    top: 7px;
    right: 8px;
    width: 24px;
    height: 24px;
    border-radius: 8px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-transition: .3s;
    -o-transition: .3s;
    transition: .3s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.9);
    }
  }

  > .thumbnail {
    display: flex;
    height: 75%;
    overflow: hidden;

    img {
      width: 100%;
      object-fit: cover;
      cursor: pointer;
    }
  }

  > .media_info {
    height: 25%;
    width: 100%;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;

    > span {
      padding: 0.25rem 0.5rem;
      border-radius: 6px;

      &.green_label {
        background-color: #DFF5EE;
        color: #0A8080;
      }
    }

    > .views {
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      color: var(--primary-font-color);

      > .icon {
        display: inline-block;
        width: 1rem;
        height: 1rem;
        background-repeat: no-repeat;
        background-position: center;

        :deep(path) {
          stroke: var(--primary-font-color);
        }
      }

      > span {
        margin-left: 0.25rem;
        font-size: .8rem;
        font-weight: 500;
        line-height: 1.3;
        letter-spacing: -0.1px;
      }
    }
  }

}

.add_media {
  width: 100%;
  height: 100%;
  margin-top: 0;
  display: block;
  border: 2px solid #37B2A8;
  border-radius: 0.75rem;
  cursor: pointer;
  padding: 0.5rem;

  > .input_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    opacity: 1;
    transition: .3s;
    padding: 0 10px;
    text-align: center;
    position: relative;
    width: 100%;
    height: 100%;

    > .icon_wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      > :deep(svg) {
        width: 3rem;
        height: 3rem;

        > path {
          stroke: #37B2A8;
        }
      }
    }

    > .title {
      color: #37B2A8;
      font-weight: 700;
      line-height: 1.45;
      letter-spacing: -0.042em;
      font-size: 1.125rem;
    }
  }
}
</style>

